import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  VStack,
  Input,
  InputGroup,
  InputLeftElement,
  FormControl,
  FormLabel,
  Checkbox,
  HStack,
  useDisclosure,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface SearchUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSearch: (email: string, options: { isActive?: boolean }) => void;
}

export const SearchUserModal = ({
  isOpen,
  onClose,
  onSearch,
}: SearchUserModalProps) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [showAdvanced, setShowAdvanced] = useState(false);

  const handleSearch = () => {
    onSearch(email, showAdvanced ? { isActive } : {});
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("login.searchUsers")}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4}>
            <FormControl>
              <InputGroup>
                <InputLeftElement pointerEvents="none">
                  <SearchIcon color="gray.300" />
                </InputLeftElement>
                <Input
                  placeholder={t("login.searchByEmail")}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </InputGroup>
            </FormControl>

            <Button
              variant="link"
              size="sm"
              onClick={() => setShowAdvanced(!showAdvanced)}
            >
              {showAdvanced ? t("login.hideAdvanced") : t("login.showAdvanced")}
            </Button>

            {showAdvanced && (
              <FormControl>
                <FormLabel>{t("login.status")}</FormLabel>
                <Checkbox
                  isChecked={isActive}
                  onChange={(e) => setIsActive(e.target.checked)}
                >
                  {t("login.activeOnly")}
                </Checkbox>
              </FormControl>
            )}
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button mr={3} onClick={handleSearch} leftIcon={<SearchIcon />}>
            {t("login.search")}
          </Button>
          <Button variant="ghost" onClick={onClose}>
            {t("login.cancel")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
